
export const getAllStore = store => store;

export const routesSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.renewMutex.newUrl = store.renewMutex.newUrl;

  retStore.filtersState.tavola = store.filtersState.tavola;
  retStore.filtersState.marca = store.filtersState.marca;

  return retStore;
}

export const pageB2CSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};
  retStore.filtersState.modello = store.filtersState.modello; 

  return retStore;
}

export const filterVMSelector = (store) =>{
  var retStore = {dataList: {}, filtersState: {}, renewMutex: {}};
  retStore.filtersState.marca = store.filtersState.marca;

  return retStore;
}

export const filterSparePartsSelector = (store) =>{
  var retStore = {dataList: {}, filtersState: {}, renewMutex: {}};
  retStore.renewMutex.applicazioni = store.renewMutex.applicazioni;
  retStore.dataList.applicazioni = store.dataList.applicazioni;
  retStore.filtersState.applicazione = store.filtersState.applicazione;
  retStore.filtersState.modello = store.filtersState.modello;
  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.cmoto = store.filtersState.cmoto;
  
  return retStore;
}

export const filterChassisSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.telaio = store.filtersState.telaio;
  retStore.filtersState.cmoto = store.filtersState.cmoto;

  return retStore;
}

export const filterModelSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.renewMutex.modelli = store.renewMutex.modelli;
  retStore.renewMutex.modelliApp = store.renewMutex.modelliApp;
  retStore.dataList.modelli = store.dataList.modelli;
  retStore.dataList.applicazioni = store.dataList.applicazioni;
  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.modello = store.filtersState.modello;
  retStore.filtersState.telaio = store.filtersState.telaio;
  retStore.filtersState.cmoto = store.filtersState.cmoto;
  retStore.filtersState.applicazione = store.filtersState.applicazione;

  return retStore;
}

export const filterTavoleSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.renewMutex.tavole = store.renewMutex.tavole;
  retStore.renewMutex.tavoleApp = store.renewMutex.tavoleApp;
  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.modello = store.filtersState.modello;
  retStore.filtersState.telaio = store.filtersState.telaio;
  retStore.filtersState.tavola = store.filtersState.tavola;
  retStore.dataList.tavole = store.dataList.tavole;
  retStore.dataList.applicazioni = store.dataList.applicazioni;
  retStore.filtersState.cmoto = store.filtersState.cmoto;


  return retStore;
}

export const pageDistintaSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.renewMutex.mostraImg = store.renewMutex.mostraImg;

  return retStore;
}

export const imgTavolaSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.renewMutex.immagineTavola = store.renewMutex.immagineTavola;
  retStore.renewMutex.mostraImg = store.renewMutex.mostraImg;
  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.modello = store.filtersState.modello;
  retStore.filtersState.tavola = store.filtersState.tavola;
  retStore.filtersState.immagine = store.filtersState.immagine;
  retStore.dataList.immagineTavola = store.dataList.immagineTavola;
  retStore.dataList.tavole = store.dataList.tavole;

  return retStore;
}

export const partsListSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.renewMutex.newUrl = store.renewMutex.newUrl;
  retStore.renewMutex.distinta = store.renewMutex.distinta;
  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.modello = store.filtersState.modello;
  retStore.filtersState.tavola = store.filtersState.tavola;
  retStore.filtersState.immagine = store.filtersState.immagine;
  retStore.filtersState.applicazione = store.filtersState.applicazione;
  retStore.dataList.distinta = store.dataList.distinta;
  retStore.dataList.wishList = store.dataList.wishList;

  return retStore;
}

export const statusBarSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.renewMutex.mostraImg = store.renewMutex.mostraImg;
  retStore.renewMutex.modelli = store.renewMutex.modelli;
  retStore.renewMutex.tavole = store.renewMutex.tavole;
  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.modello = store.filtersState.modello;
  retStore.filtersState.tavola = store.filtersState.tavola;
  retStore.filtersState.telaio = store.filtersState.telaio;
  retStore.filtersState.distintaGruppo = store.filtersState.distintaGruppo;
  retStore.filtersState.newUrl = store.filtersState.newUrl;
  retStore.dataList.modelli = store.dataList.modelli;
  retStore.dataList.tavole = store.dataList.tavole;

  return retStore;
}

export const wishListSelector = (store) =>{
  var retStore = {renewMutex: {}, filtersState: {}, dataList: {}};

  retStore.dataList.wishList = store.dataList.wishList;

  return retStore;
}


export const modalItemSelector = (store) => {
  var retStore = { renewMutex: {}, filtersState: {}, dataList: {} };

  retStore.dataList.wishList = store.dataList.wishList;
  retStore.filtersState.marca = store.filtersState.marca;
  retStore.filtersState.modello = store.filtersState.modello;
  retStore.filtersState.tavola = store.filtersState.tavola;
  retStore.dataList.modelli = store.dataList.modelli;
  retStore.dataList.tavole = store.dataList.tavole;
  retStore.filtersState.applicazione = store.filtersState.applicazione;

  return retStore;
}